module.exports = __webpack_public_path__ + "static/media/ServicesnBulkPaymentIcon.01c01131.svg";